import React, { useEffect, useRef } from 'react';
import './SobreNos.css';

const diferenciais = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
    title: 'FOCO EM EFICIÊNCIA',
    desc: 'Soluções que otimizam espaços e processos.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: 'QUALIDADE E SEGURANÇA',
    desc: 'Estruturas robustas e confiáveis para sua operação.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
    title: 'PROJETOS PERSONALIZADOS',
    desc: 'Desenvolvidos para atender às necessidades do seu negócio.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
    title: 'RESULTADOS QUE GERAM VALOR',
    desc: 'Mais desempenho, produtividade e competitividade para sua empresa.',
  },
];

function SobreNos() {
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('sobre__animate--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    if (leftRef.current) observer.observe(leftRef.current);
    if (rightRef.current) observer.observe(rightRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="sobre" id="sobre">
      <div className="sobre__container">

        {/* Lado esquerdo — texto */}
        <div className="sobre__left sobre__animate sobre__animate--left" ref={leftRef}>
          <p className="sobre__subtitle">NOSSA HISTÓRIA</p>
          <h2 className="sobre__title">
            Construindo Soluções em Armazenagem
          </h2>
          <p className="sobre__text">
            Desde o início, a MSA vem construindo soluções em armazenagem com foco em eficiência,
            qualidade e resultado. Ao longo da nossa trajetória, desenvolvemos projetos personalizados
            que atendem às necessidades de cada cliente, sempre buscando o melhor aproveitamento de
            espaço e desempenho operacional. Nosso compromisso é entregar estruturas seguras,
            duráveis e que realmente façam a diferença no dia a dia das empresas.
          </p>
        </div>

        {/* Lado direito — imagem */}
        <div className="sobre__right sobre__animate sobre__animate--right" ref={rightRef}>
          {/* Placeholder até a imagem ser enviada */}
          <div className="sobre__image-placeholder">
            <img src="/sobre-nos/image1.avif" alt="Sobre a MSA" style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}} />
          </div>
        </div>

      </div>
    </section>
  );
}

export default SobreNos;
